import { render, staticRenderFns } from "./draft_note.vue?vue&type=template&id=79d816e0&vue3"
import script from "./draft_note.vue?vue&type=script&lang=js&vue3"
export * from "./draft_note.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports